/*
 * @LastEditors: donsonwu
 * @Date: 2022-08-24 10:14:30
 * @LastEditTime: 2022-10-19 15:09:29
 * @Descripttion:
 */
import { btnGrayNormalHandle, TGDialogS, initShareFunc, copyText, getUrlParam } from '../utils'
import { amsBtn } from '../AmsAndMilo/amsBtnTypeLimit'
import { AmsService } from '../AmsAndMilo/amsSubmit'
import { iActivityId, giftId, initFlow, wxBindPopId, preRolePopId, plat, isPage } from './config'
import milo from '@tencent/milo-web'

export function initPage(needSubmit: boolean = true, popMask: boolean = false) {
  if (needSubmit) {
    milo.Lottery.init({
      plat: plat,
      iActivityId:iActivityId,
      iFlowId: initFlow,
      withAreaInfo: false,
      forbidLoading: popMask || true,
      // flowConfig: {
      //   sData: sData
      // },
      onSuccess: (callbackObj) => {
        initFunction(callbackObj)
      },
      onFail: (callbackObj) => {
        console.log(callbackObj)
        const msg = callbackObj.sMsg || callbackObj.msg
        // 抽奖失败事件
        if (callbackObj.iRet == '202') {
          TGDialogS(wxBindPopId)
          milo.miloAlert(msg)
        } else if (msg === '抱歉，您还没有角色，无法参与~' || msg === '抱歉，您还未拥有角色，无法参与~') {
          // 拉起来预创角
          milo.miloAlert(msg)
          TGDialogS(preRolePopId)
        } else {
          milo.miloAlert(msg)
        }
        return
      },
    }).then(lottory => {
      lottory.getGift()
    })
  } else {
    initFunction((window as any).cfhdCallbackObj[iActivityId])
  }
}
// ;(window as any).cfhdCallbackObj[iActivityId] = { sOutValue1: '', sOutValue2: '', sOutValue3: '', sOutValue4: '', sOutValue5: '', sOutValue6: '', sOutValue7: '', sOutValue8: '' }
// 需要开发自定义函数  NEED TODO
if ((window as any).cfhdCallbackObj == undefined) {
  ;(window as any).cfhdCallbackObj = {} // 一定需要
}



// 需要开发人员手工更改  NEED-TODO
const btnClassList1: Array<amsBtn> = [

  { class: '.cfhd_gift_1', flowId: 898571, key: 'sOutValue1', postion: '0' },

]


export const allBtn = [...btnClassList1]
// const amsService = new AmsService(allBtn)

// 初始化成功回调
let onceCtrl = false
// 需要开发人员手工更改  NEED-TODO
export function initFunction(callbackObj) {
  ;(window as any).cfhdCallbackObj[iActivityId] = callbackObj
  // 按钮置灰
  btnGrayNormalHandle((window as any).cfhdCallbackObj[iActivityId], allBtn, 'gray')
  console.log(callbackObj)
}
function getCFArea1(ele: amsBtn) {
  if ((window as any).CFbind.CFareaidsure != 0) {
    ;(window as any)[`sData${ele.class}`].area = (window as any).CFbind.CFareaidsure
    return true
  } else {
    (window as any).CFbind.initbind()
    return false
  }
}
function getShareCode(ele: amsBtn) {
  if (getUrlParam('shareCode')) {
    ;(window as any)[`sData${ele.class}`].shareCode = getUrlParam('shareCode')
    return true
  } else {
    milo.miloAlert('请确认您的邀请链接~')
    return false
  }
}